import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['icon', 'content', 'sideContent']
  static values = { dropdown: String }

  declare readonly iconTarget: HTMLElement
  declare readonly contentTarget: HTMLElement
  declare readonly sideContentTarget: HTMLElement
  declare readonly dropdownValue: string

  connect (): void {
    document.addEventListener('scroll', this.hideSideContent.bind(this))
    document.addEventListener('click', this.handleClickOutside.bind(this))

    this.handleContent(this.isSidebarExpanded() && this.isContentExpanded())
  }

  disconnect (): void {
    document.removeEventListener('scroll', this.hideSideContent.bind(this))
    document.removeEventListener('click', this.handleClickOutside.bind(this))
  }

  handleClickOutside (event: Event): void {
    const dropdown = event.target as HTMLElement

    if (!this.element.contains(dropdown)) {
      this.hideSideContent()
    }
  }

  hideSideContent (): void {
    this.addClassToTarget(this.sideContentTarget, 'hidden')
  }

  toggle (): void {
    if (this.isSidebarExpanded()) {
      this.toggleContent()
    } else {
      this.toggleSideContent()
    }
  }

  handleDropdownContent (isShown: boolean): void {
    if (isShown && !this.isContentExpanded()) return

    this.handleContent(isShown)
  }

  private handleContent (isShown: boolean): void {
    if (isShown) {
      this.contentTarget.classList.remove('hidden')
      this.addClassToTarget(this.iconTarget, 'rotate-180')
    } else {
      this.addClassToTarget(this.contentTarget, 'hidden')
      this.iconTarget.classList.remove('rotate-180')
    }
  }

  private isSidebarExpanded (): boolean {
    return localStorage.getItem('sidebarState') === 'false'
  }

  private isContentExpanded (): boolean {
    return sessionStorage.getItem(this.dropdownValue) === 'true'
  }

  private toggleContent (): void {
    const newIsContentExpanded: boolean = !this.isContentExpanded()

    this.handleContent(newIsContentExpanded)
    sessionStorage.setItem(this.dropdownValue, String(newIsContentExpanded))
  }

  private toggleSideContent (): void {
    this.sideContentTarget.classList.toggle('hidden')
    this.sidebarPositionPopover()
  }

  private sidebarPositionPopover (): void {
    const triggerRect = this.element.getBoundingClientRect()
    const top = triggerRect.top + triggerRect.height

    this.sideContentTarget.style.top = `${top}px`
    this.sideContentTarget.style.left = '57px'
  }

  private addClassToTarget (target: HTMLElement, klass: string): void {
    const alreadyAssigned: boolean = target.classList.contains(klass)

    if (!alreadyAssigned) target.classList.add(klass)
  }
}
